export default __webpack_public_path__ + "factory.png";